<template>
  <div class="caigou">
      <jzcgheader></jzcgheader>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mbx">
        <el-breadcrumb-item :to="{ path: '/jicailist' }">集中采购</el-breadcrumb-item>
        <el-breadcrumb-item >发布集采</el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-form ref="form" :rules="rules" style="width:1000px;margin: 0 auto" :model="form" label-width="100px">
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" placeholder="请输入标题" style="width:90%;"></el-input>
          </el-form-item>
          <el-form-item label="所属行业" prop="industry">
          <el-select v-model="form.industry" placeholder="请选择">
            <el-option
                      v-for="item in getIndustryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
</el-select>
        </el-form-item>
          <el-form-item label="截止时间" prop="endTime">
            <el-date-picker
          
      v-model="form.endTime"
      :picker-options="pickerOptions"
      type="date"
      placeholder="选择日期">
    </el-date-picker>
            </el-form-item>
            <el-form-item label="描述" prop="description">
              <el-input
  type="textarea"
  style="width:90%;"
  :rows="2"
  placeholder="请输入内容"
  v-model="form.description">
</el-input>
              </el-form-item>
              <el-form-item label="上传附件"  prop="img">
                <el-upload
  class="upload-demo"
  :action="baseUrl+'/blade-resource/oss/endpoint/put-file'"
  :on-preview="handlePreview"
  :on-remove="handleRemove"
  :before-remove="beforeRemove"
  :on-success="handleSuccess"
  multiple
  :limit="3"
  :on-exceed="handleExceed"
  :file-list="fileList">
  <el-button size="small" type="primary">点击上传</el-button>
  <div slot="tip" class="el-upload__tip">支持excel、word、jpg、pdf格式的文件可上传多张，建议文件大小不超过500k</div>
</el-upload>
            <!-- <div style="position: relative">
              <input type="file" class="attachment" ref="attachment1"  @change="uploadFile1">
              <i class="el-icon-plus"  v-if="!form.img"></i>
              <span  class="zhizhao" v-if="form.img">
              <img :src="form.img"/>
              </span>
            </div> -->
          </el-form-item>
          <el-form-item label="封面图"  prop="img">
            <div style="position: relative">
              <input type="file" class="attachment" ref="attachment1"  @change="uploadFile1">
              <i class="el-icon-plus"  v-if="!form.img" style="cursor: pointer;"></i>
              <span  class="zhizhao" v-if="form.img">
              <img :src="form.img"/>
              </span>
            </div>
          </el-form-item>
          <span v-for="(item,index) in form.products" :key="item.id" style="margin:20px 0;"> 
            <p style="margin-left:50px;">产品{{index+1}}       <el-button v-if="index>=0" type="danger" size="mini" @click="btnRmProduct(index)" style="margin-left:20px;">
            删除
          </el-button></p>
          <el-row>
            <el-col :span="12"><div >
    <el-form-item label="产品名称"  :prop="'products.' + index + '.name'" :rules="rules.name">
            <el-input v-model="item.name" placeholder="请输入产品名称" style="width:220px;"></el-input>
          </el-form-item>
  </div></el-col>
  <el-col :span="12"><div >
    <el-form-item label="产品分类"  :prop="'products.' + index + '.category'" :rules="rules.category">
            <!-- <el-input v-model="item.category" placeholder="请输入产品名称"></el-input> -->
            <el-cascader

    v-model="item.category"
    :options="optionsCategory"
    :props="{ expandTrigger: 'hover',label:'name',value:'id' }"
    ></el-cascader>
          </el-form-item>
  </div></el-col>

</el-row>
<el-row>
  <el-col :span="12">
    <el-form-item label="计划采集数量"  :prop="'products.' + index + '.planQty'" :rules="rules.planQty">
            <el-input v-model="item.planQty" placeholder="请输入计划采集数量" style="width:220px;"></el-input>
          </el-form-item>
    <div >

  </div></el-col>
  <el-col :span="12"><div >
    <el-form-item label="计量单位"  :prop="'products.' + index + '.unit'" :rules="rules.unit">
            <el-input v-model="item.unit" placeholder="请输入计量单位" style="width:220px;"></el-input>
          </el-form-item>
  </div></el-col>
</el-row>
         
        
        
        
         
          <el-form-item label="描述" prop="remark">
              <el-input
  type="textarea"
  style="width:90%;"
  :rows="2"
  placeholder="请输入描述"
  v-model="item.remark">
</el-input>
              </el-form-item>
          </span>
          <el-form-item label=""  >
            <el-button type="primary" size="mini" @click="btnAddProduct" style="float:right;margin-top:30px;margin-right:80px;">
            +产品
          </el-button>
          </el-form-item>
          <el-form-item label="发布企业"  prop="fabuqiye">
            <el-input v-model="form.fabuqiye" placeholder="请输入发布企业" :readonly="true" style="width:220px;"></el-input>
          </el-form-item>

          <el-row>
  <el-col :span="12"><div >
    <el-form-item label="联系人"  prop="contactPerson">
            <el-input v-model="form.contactPerson" placeholder="请输入联系人" style="width:220px;"></el-input>
          </el-form-item>

  </div></el-col>
  <el-col :span="12"><div >
    <el-form-item label="联系电话"  prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入联系电话" style="width:220px;"></el-input>
          </el-form-item>

  </div></el-col>
</el-row>
       
        
          <!-- <el-form-item label="营业执照"  prop="license">
            <div style="position: relative">
              <input type="file" class="attachment" ref="attachment1"  @change="uploadFile1">
              <i class="el-icon-plus"  v-if="!form.license"></i>
              <span  class="zhizhao" v-if="form.license">
              <img :src="form.license"/>
              </span>
            </div>
          </el-form-item> -->
          <!--          <el-form-item label="申请人姓名"  prop="reqPersonName">-->
          <!--            <el-input v-model="form.reqPersonName" placeholder="请输入申请人姓名"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="申请人证件类型"  prop="reqPersonIdType">-->
          <!--            <el-select v-model="form.reqPersonIdType" placeholder="请选择证件类型">-->
          <!--              <el-option :label="item.title" v-for="(item,index) in COMMON_ID_TYPE" :key="index" :value="item.id"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="申请人证件号码"  prop="reqPersonId">-->
          <!--            <el-input v-model="form.reqPersonId" placeholder="请输入申请人证件号码"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="申请人手机号码"  prop="reqPersonPhone">-->
          <!--            <el-input v-model="form.reqPersonPhone" placeholder="请输入申请人手机号码"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="申请人职位"  prop="reqPersonPost">-->
          <!--            <el-input v-model="form.reqPersonPost" placeholder="请输入申请人职位"></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item style="text-align: center;">
            <p>  <el-radio v-model="radioRead" label="2">我已阅读并同意<span style="color:orange;">《集采服务协议》</span></el-radio></p>
            <el-button type="primary" @click="onSubmit('form')" :disabled="canPublish">发布</el-button>
            <!-- <el-button @click="goback">返回</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <!-- <el-dialog title="发送" width="600px" append-to-body :visible.sync="dialogTableVisible">
        <el-form ref="form" :model="shen" label-width="120px" :rules="rules">
          <el-form-item label="咨询详情" prop="detail">
            <el-input rows="5"  style="width: 300px" type="textarea" v-model="shen.detail"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contacts">
            <el-input   v-model="shen.contacts"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input type="number" v-model="shen.phone"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-top: 20px" @click="submitForm()">保存</el-button>
            <el-button @click="dialogTableVisible=!dialogTableVisible">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog> -->
    </div>
  </div>
</template>
<script>
import jzcgheader from './jzcgheader'
import {
  inventorygetIndustryList,

} from "../../request/moudle/jzcg";

import {getCategoryList,centerpurchasesubmit} from "../../request/moudle/jizhongcaigou"
import {mapGetters} from "vuex";
import config from "../../utils/config";
export default {
  name: "fabujicai",
  beforeRouteEnter(to, from, next){
    if(from.name=='kucunxq'){
      next((vm) => {
        vm.form=vm.xiaoshouform
      })
    }else{
      next()
    }
  },
  computed: {
    ...mapGetters(["xiaoshouform"]),
  },
  data(){
    var validatePass = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请填写统一社会信用代码'));
      } else if(!validateUnifiedSocialCreditCode(value)){
        callback(new Error('请填写正确的社会信用代码'));
      }else {
        callback();
      }
    };
    var checkEmail = (rule, value, callback) => {//邮箱校验
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空!'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式!'))
        }
      }, 100)
    };
    return {
      pickerOptions: { 
         disabledDate(time) {
            //选择今天以及今天之后的日期 
            return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择
            //选择今天以及今天之前的日期 
            return time.getTime() > Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的 
         }
        },
      canPublish:false,
      baseUrl:(process.env["VUE_APP_BASE_URL"] || '/') + 'api',
      fileList: [],
      userInfo:  this.common.getSessionStorage('userInfo'),
      ///
    
      page:{
        current:1,
        size:12,
        total:0
      },
      shen:{},
      zxid:'',
      // rules: {
      //   num:[
      //   { required: true, message: '请输入', trigger: 'blur' },
      //   ],
      //   detail: [
      //     { required: true, message: '请输入', trigger: 'blur' },
      //   ],
      //   contacts: [
      //     { required: true, message: '请输入', trigger: 'blur' },
      //   ],
      //   phone: [
      //     { required: true, message: '请输入', trigger: 'blur' },
      //   ]
      // },
      dialogTableVisible:false,
      items:[],
      form:{
        products:[
    
      ],
      img:'',
        fabuqiye:'',
        files:'',
        // name:'',
        // usci:'',
        // regTime:'',
        // regCapital:'',
        // legalPersonName:'',
        // legalPersonIdType:'',
        // legalPersonId:'',
        // regAddress:'',
        // industry:'',
        // description:'',
        // legalPersonPhone:'',
        // businessScope:'',
        // contactPerson:'',
        // contactPhone:'',
        // contactEmail:'',
        // reqPersonName:'',
        // reqPersonIdType:'',
        // reqPersonId:'',
        // reqPersonPhone:'',
        // reqPersonPost:'',
        // license:'',
        // logo:'',
        // reportDeptId:'',
        // reportDeptName:''
      },
      imageUrl:'',
      rules:{
        title:[
        { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        industry: [
          { required: true, message: '请选择所属行业', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择截止时间', trigger: 'change' }
        ],

        name: [
          { required: true, trigger: 'blur', message:'请填写产品名称' }
        ],
        category: [
          { required: true, trigger: 'change', message:'请选择产品分类' }
        ],
        planQty: [
          { required: true, trigger: 'blur', message:'请填写计划采集数量' }
        ],
        unit: [
          { required: true, trigger: 'blur', message:'请填写计量单位' }
        ],
        // remark: [
        //   { required: true, trigger: 'blur', message:'请填写备注' }
        // ],
        // usci:[
        //   { validator: validatePass, required: true, trigger: 'blur'}
        // ],
        // regTime:[
        //   { required: true, message: '请填写注册时间', trigger: 'change',  }
        // ],
        // regCapital: [
        //   { required: true, trigger: 'blur', message: '请填写注册资本'  }
        // ],
        // legalPersonPhone: [
        //   { required: true, trigger: 'blur', message:'请填写法定代表人电话' }
        // ],
        // legalPersonName: [
        //   { required: true, trigger: 'blur', message:'请填写法定代表人姓名' }
        // ],
        // regAddress:[
        //   { required: true, trigger: 'change', message: '请填写注册地址' }
        // ],
        // industry: [
        //   { required: true, trigger: 'blur', message: '请选择所属行业' }
        // ],
        // businessScope: [
        //   { required: true, trigger: 'blur', message: '请填写经营范围'  }
        // ],
        contactPerson: [
          { required: true, trigger: 'blur', message:'请填写联系人' }
        ],
        contactPhone: [
          { required: true, trigger: 'blur', message:'请填写联系电话'}
        ],
        // contactEmail: [
        //   { required: true, validator: checkEmail, trigger: 'blur'}
        // ],
        // license: [
        //   { required: true, trigger: 'blur', message:'请填写'}
        // ],
        // reportDeptName: [
        //   { required: true,  message:'请选择园区'}
        // ],
        // reqPersonName: [
        //   { required: true, trigger: 'blur', message:'请填写申请人姓名'}
        // ],
        // reqPersonPhone: [
        //   { required: true, trigger: 'blur', message: '请填写申请人手机号码' }
        // ],
        // reqPersonPost: [
        //   { required: true, message: '请填写申请人职位', trigger: 'blur' }
        // ],
        // contactEmail: [
        //   { required: true, validator: checkEmail, trigger: 'blur' }
        // ]
      },
      radioRead:false,
      optionsCategory:[
   
      ],
      getIndustryList:[],


        ///
    }
  },
  mounted() {
 
    this.form.fabuqiye=this.userInfo.detail.tenantName;
    this.loadconfig()
    this.loadlist()
    this.form.products.push({});
  },
  methods:{

    uploadFile1(event){
      console.log(event)
      let inputDOM = this.$refs.attachment1;
      //通过DOM取文件数据
      this.fileData = inputDOM.files;
      let _file = this.fileData[0]
      if(!_file){return;}
      let size = Math.floor(_file.size / 1024);
      if (size > this.maxSize) {
        this.$toast('单个文件大小不超过15M！');
        return false
      }

      if(!/image\/\w+/.test(_file.type)){
        this.$toast('请确保文件为图片类型')
        return false;
      }
      console.log(_file,'_file')
      var fd = new FormData();
      fd.append("file", _file);
      this.$api.index.batchupload(fd).then((res)=>{
      
        this.form.img=res.data.link
      })
    },
    handleSuccess(response, file, fileList){
      this.fileList.push({name:response.data.originalName,url:response.data.link})
    },
    handleRemove(file, fileList) {
        console.log(file, fileList);
        let url = file.url;
        const sheng=this.fileList.filter(item=>{
          return item.url!=url;
        })
        this.fileList=sheng;
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
    login(){
      this.$router.push({
        path:'/login'
      })
    },

    getFmtDate(timeP){
      const date = new Date(timeP);
  const year=date.getFullYear();
  const month=(date.getMonth()+1)<10?'0'+(date.getMonth()+1):date.getMonth()+1;
  const day=date.getDate()<10?'0'+date.getDate():date.getDate();

  
  const tm= `${year}-${month}-${day} 00:00:00`;
  return tm;
    },
    onSubmit(){





      if(!this.common.getSessionStorage('userInfo')){
        this.$msgbox.confirm('您还未登录, 是否去登录?', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '继续浏览',
          type: 'warning'
        }).then(() => {
          window.location.replace(config.pchref)
        })
        return
      }
      // alert(JSON.stringify(this.fileList) );
      // alert(JSON.stringify(this.form.products));
      if(this.form.products.length==0){
        this.$message({
          type: "error",
          message: "最少添加一个产品!"
        });
        return;
        // done();
      
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(!this.radioRead){
                   this.$message({
              type: "error",
              message: "请勾选我已阅读并同意!"
            });
          return;
          }

          let ids=this.form.products.map(item=>{
        return {...item,...{category:item.category.join(',')}}
      })
      this.form.products=ids;
      const urlArray=this.fileList.map(item=>{return item.url});
      this.form.files=urlArray.join(',');
      //格式化时间
    
      this.canPublish=true;
          centerpurchasesubmit({...this.form,...{endTime:this.getFmtDate(this.form.endTime)}}).then(res=>{
            this.canPublish=false;
                  this.$message({
              type: "success",
              message: "提交成功!"
            });
            this.$router.push({
        path:'/jicailist'
      })
          }).catch(err=>{
            this.canPublish=false;
          })
          // this.shenzx.productType = "purchase-quote"
          // this.shenzx.productId = this.$route.query.id
          // this.$api.logistics.consultMessage(this.shenzx).then((res)=>{
          //   this.dialogTableVisiblezx=false
          //   this.$message({
          //     type: "success",
          //     message: "提交成功!"
          //   });
          // })
        }
      })
    },
    btnAddProduct(){
      this.form.products.push({});
    },
    btnRmProduct(index){
      if(this.form.products.length<=1){
        this.$message({
          type: "error",
          message: "最少添加一个产品!"
        });
        return;
      }
      this.form.products.splice(index, 1)
    },

getTreeData(data) {
    for (let i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
              // 最后一级没有数据将children变成undefined
             data[i].children = undefined;} else {
             // children不为空时继续调用该方法
             this.getTreeData(data[i].children);
             }
        }
    return data;

      },
    loadconfig(){
      this.$api.demand.inventorygetIndustryList().then((res)=>{
        this.getIndustryList=res.data
      })
      // this.$api.demand.inventorygetTypeList().then((res)=>{
      //   this.getTypeList=res.data
      // })
      getCategoryList().then(res=>{
        console.log('二级分类',res.data);

        let dataFinal=res.data;
        this.getTreeData(dataFinal);
        this.optionsCategory=dataFinal;
      }).catch()
    },
    submitForm(){
   
      this.shen.inventoryId=this.zxid
      this.$api.demand.inventorysubmitconsult(this.shen).then((res)=>{
        this.dialogTableVisible=false
        this.$message({
          type: "success",
          message: "提交成功!"
        });
      })
    },
    zixun(item){
      this.shen={}
      this.zxid=item.id
      this.dialogTableVisible=true
    },
    goxq(item){
      this.$router.push({
        path:'/kucunxq',
        query:{
          id:item.id,
        }
      })
    },
    loadlist(bol){
      if(bol){
        this.page.current=1
      }
      if(this.form.cascader){
        this.form.province=this.form.cascader[0]
        this.form.city=this.form.cascader[1]
        this.form.area=this.form.cascader[2]
      }
      const obj={
        ...this.form
      }
      this.$store.commit("setxiaoshouform",this.form);
      obj.current=this.page.current
      obj.size=this.page.size
      this.$api.demand.inventorylist(obj).then((res)=>{
        this.items=res.data.records
        this.page.total=res.data.total
      })
    },
    handleSizeChange(val){
      this.page.size=val
      this.loadlist()
    },
    handleCurrentChange(val) {
      this.page.current=val
      this.loadlist()
    },
    reset(){
      this.form={}
    },
  
  },
  components:{
    jzcgheader
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-input{
  width: auto;
}
.caigou{
  background: #F5F5F5;
}
.colorC8{
  color: #C8C8C8;
}
.botline{
  padding-top: 15px;
  border-top: 1px dashed;
  margin-top: 15px;
}
.product{
  border-right: 1px solid ;
  margin-right: 8px;
  padding-right: 8px;
}
.color00{
  color: #0078F2;
}
  .content{
    width: 1200px;
    margin: 15px auto;
    .line{
      position: relative;
    }
    .sxx{
      background:#FFFFFF;
      padding:30px  40px;
      margin-top: 25px;
    }
    .fenye{
      text-align: center;
      padding: 30px 0;
      background: #fff;
    }
    .lists{
      overflow: hidden;
      background: #ffffff;
      padding:35px  20px;
      margin-top: 25px;
    }
    .list{
      width: 350px;
      border: 1px solid #D1D1D1;
      border-radius: 8px;
      float: left;
      margin-left: 20px;
      margin-bottom: 20px;
      line-height: 25px;
      cursor: pointer;
      .listimage{
        height: 240px;
        position: relative;
      }
      .biao{
        width: 24px;
        height: 24px;
        border-radius: 1px;
        background: #CCABDA;
        color: #fff;
        text-align: center;
        line-height: 24px;
        position: absolute;
        top: 5px;
        left: 5px;
        z-index: 99;
      }
      .title{
        font-size: 16px;
        color: #000000;
        font-weight: bolder;
        margin: 10px 0;
        min-height: 50px;
      }
      .cardred{
        color: red;
        font-size: 16px;
        font-weight: bolder;
        margin-top: 5px;
      }
      .card{
        width: 100%;
        display: inline-block;
      }
      .el-icon-location{
        font-size: 32px;
        color: #D83434;
        vertical-align: middle;
      }
      .address{
        vertical-align: middle;
      }
      .see{
        display: inline-block;
        width: 110px;
        cursor: pointer;
        background: linear-gradient(0deg,#6EC6CA,#6EC6CA);
        color: #fff;
        text-align: center;
        float: right;
        border-radius: 4px;
      }
      .h1{
        margin: 20px 25px;
      }
    }
  }
  .el-icon-plus{
  font-size: 30px;
  color: #606266;
  margin: 5px 10px;
}
.attachment{
  position: absolute;
  left: 7px;
  top: -3px;
  z-index: 999;
  opacity: 0;
  height: 50px;
  width: 50px;
}
.zhizhao{
  width: 50px;
  height: 50px;
  position: absolute;
  left: 7px;
  top: -3px;
  z-index: 900;
  img{
    width: 100%;
    height: 100%;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}


.zhizhao{
  width: 50px;
  height: 50px;
  position: absolute;
  left: 7px;
  top: -3px;
  z-index: 900;
  img{
    width: 100%;
    height: 100%;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>